import React, { PropsWithChildren, useState } from 'react';
import styled from 'styled-components';
import Icon from '../Donee/components/common/Icon';
import { Text } from '../Donee/components/common/Text/Text';
import { SecuredCheck } from '../icons';
import { Button, Modal } from '../ui';

const StyledDiv = styled.div`
    display: flex;
    cursor: pointer;
    .lock-icon {
        margin-top: -2px;
    }
    .text {
        cursor: pointer;
        margin-left: 8px;
        margin-right: 4px;
    }
    .right-arrow {
        width: 9px;
        height: 9px;
    }
`;

const StyledModalContentDiv = styled.div`
    padding-top: 36px;
    text-align: center;
    .icon {
        margin-bottom: 26px;
    }
    .margin-bottom {
        margin-bottom: 24px;
    }
`;

export interface SecureProps {
    id?: string;
    text?: string;
    className?: string;
}

export const Secure: React.FC<SecureProps & PropsWithChildren> = ({
    id = 'security-info',
    text = 'Your information is secure',
    className,
    children,
}) => {
    const [open, setOpen] = useState<boolean>(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    return (
        <>
            <StyledDiv
                id={id}
                onClick={handleOpen}
                className={className}
            >
                <Icon
                    id={`${id}-lock-icon`}
                    size={'small'}
                    fluid={undefined}
                    name={'lock-icon'}
                    className={'lock-icon'}
                    color={'primarySecondaryContent'}
                />
                <Text
                    id={`${id}-label`}
                    variant={'xSmall'}
                    weight={'bold'}
                    onClick={undefined}
                    color={'primarySecondaryContent'}
                    className={'text'}
                >
                    {text || children}
                </Text>
                <Icon
                    id={`${id}-details-icon`}
                    size={'xSmall'}
                    fluid={undefined}
                    name={'history-list-arrow'}
                    color={'utilityInputColor'}
                    className={'right-arrow'}
                />
            </StyledDiv>
            <Modal
                id={`${id}-modal`}
                open={open}
                onClose={handleClose}
            >
                <StyledModalContentDiv
                    className="w-[412px] mobile:w-full"
                    id={`${id}-modal-body`}
                >
                    <SecuredCheck
                        id={`${id}-modal-secured-icon`}
                        className={'icon'}
                    />
                    <div
                        id={`${id}-modal-title`}
                        className="text-body-large text-center mb-6"
                    >
                        Your information is secure
                    </div>
                    <div
                        id={`${id}-modal-description`}
                        className="text-body-medium text-center mb-6"
                    >
                        Givelify never stores card data on your phone. We use
                        PCI compliant, military-grade encryption to protect all
                        sensitive data.
                    </div>
                    <Button
                        id={`${id}-modal-dismiss-button`}
                        onClick={handleClose}
                        className="w-full"
                    >
                        Got it, thanks!
                    </Button>
                </StyledModalContentDiv>
            </Modal>
        </>
    );
};
